import { styled } from '@mui/material/styles';

export const SelfRegisterRoot = styled('div')({
  flexGrow: 1,

  '& .titleContainer': {
    maxWidth: 'none',
    alignSelf: 'center',

    '& > div': {
      justifyContent: 'center',
    },
  },
});

export const SelfRegisterContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const SelfRegisterLogoHeader = styled('div')({
  // EImage's inner flex wrapper left-aligns by default; center like NavBar (PFM-2625).
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 150,
  '& .IMAGE': {
    height: 150,
    width: '100%',
    maxWidth: 250,
  },
  '& .IMAGE > div': {
    justifyContent: 'center',
    width: '100% !important',
    height: '100% !important',
    marginLeft: 0,
    marginRight: 0,
  },
  '& .IMAGE img': {
    objectFit: 'contain',
    width: 'auto !important',
    height: 'auto !important',
    maxWidth: '100%',
    maxHeight: '100%',
  },
});

export const SelfRegisterPerformLogo = styled('div')({
  margin: '0 auto',
  width: 150,
});
